export enum enumBillingJobStates {
	generateQuote = 85,
	assessmentInvoice = 25,
	invoiceUpdatedValid = 46,
	invoiceUpdatedInvalid = 47,
	assessmentCil = 66,
	assessmentWarranty = 67,
	assessmentSmallJob = 69
}
